import React from 'react';
import SeoMeta from '../components/SeoMeta';
import PageHero from '../components/PageHero';
import FadeIn from '../components/FadeIn';

export default function PrivacyPolicy() {
  return (
    <main className="bg-brand-vintage pb-0">
      <SeoMeta 
        title="Privacy Policy | Padua Weddings" 
        description="How Padua Weddings collects, uses, and protects visitor information." 
      />
      
      <PageHero 
        title="Privacy Policy" 
        subtitle="How Padua Weddings collects, uses, and protects visitor information."
        image="https://ik.imagekit.io/aeu02xvjgn/i-Wh5HSCQ-X3.jpg"
      />

      <section className="py-24 md:py-32 bg-white px-6">
        <div className="max-w-3xl mx-auto font-sans font-light text-brand-charcoal/80 leading-relaxed">
          <FadeIn>
            <div className="space-y-10">
              <div>
                <p className="mb-4"><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                <p>Padua Weddings ("we," "our," or "us") respects your privacy and is committed to protecting it through our compliance with this policy. This Privacy Policy describes the types of information we may collect from you or that you may provide when you visit paduaweddings.com (our "Website") and our practices for collecting, using, maintaining, protecting, and disclosing that information.</p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-brand-charcoal mb-4">1. Information We Collect</h2>
                <p className="mb-4">We collect several types of information from and about users of our Website, including:</p>
                <ul className="list-disc pl-6 space-y-3">
                  <li><strong>Personal Information:</strong> Name, email address, phone number, wedding/event date, estimated guest count, and any other information you provide when filling out forms on our Website (e.g., booking a tour or requesting an estimate).</li>
                  <li><strong>Usage Data:</strong> Information about your internet connection, the equipment you use to access our Website, and usage details collected automatically as you navigate through the site (e.g., IP addresses, browser type, and operating system).</li>
                </ul>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-brand-charcoal mb-4">2. How We Use Your Information</h2>
                <p className="mb-4">We use information that we collect about you or that you provide to us, including any personal information:</p>
                <ul className="list-disc pl-6 space-y-3">
                  <li>To present our Website and its contents to you.</li>
                  <li>To provide you with information, pricing, or services that you request from us (such as scheduling a private tour or providing a custom estimate).</li>
                  <li>To fulfill any other purpose for which you provide it.</li>
                  <li>To notify you about changes to our Website or any products or services we offer or provide though it.</li>
                  <li>To improve our Website, marketing, and customer service.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-brand-charcoal mb-4">3. Cookies and Tracking Technologies</h2>
                <p>We may use cookies, web beacons, and other tracking technologies to collect information about your browsing activities across third-party websites. This helps us improve our Website and deliver a better and more personalized service. You can set your browser to refuse all or some browser cookies, but this may affect your experience on our Website.</p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-brand-charcoal mb-4">4. Disclosure of Your Information</h2>
                <p>We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when its release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property, or safety.</p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-brand-charcoal mb-4">5. Data Security</h2>
                <p>We have implemented measures designed to secure your personal information from accidental loss and from unauthorized access, use, alteration, and disclosure. However, the transmission of information via the internet is not completely secure. Although we do our best to protect your personal information, we cannot guarantee the security of your personal information transmitted to our Website.</p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-brand-charcoal mb-4">6. Changes to Our Privacy Policy</h2>
                <p>It is our policy to post any changes we make to our privacy policy on this page. If we make material changes to how we treat our users' personal information, we will notify you through a notice on the Website home page.</p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-brand-charcoal mb-4">7. Contact Information</h2>
                <p className="mb-4">To ask questions or comment about this privacy policy and our privacy practices, contact us at:</p>
                <div className="bg-brand-vintage/50 p-6 border border-brand-stone/20 rounded-sm">
                  <p className="mb-1"><strong>Padua Weddings</strong></p>
                  <p className="mb-1">4467 Padua Ave</p>
                  <p className="mb-4">Claremont, CA 91711</p>
                  <p className="mb-1">Email: <a href="mailto:paduahillstheatre@gmail.com" className="text-brand-olive hover:text-brand-charcoal transition-colors">paduahillstheatre@gmail.com</a></p>
                  <p>Phone: <a href="tel:909-624-8628" className="text-brand-olive hover:text-brand-charcoal transition-colors">909-624-8628</a></p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </main>
  );
}